(function() {
    function funcReady() {
        $('.KRC0009').buildCommonUI();

        vcui.require(['ui/carousel'], function () {
            $('.KRC0009').find('.ui_carousel_slider').vcCarousel({
                infinite: false,
                prevArrow:'.btn-arrow.prev',
                nextArrow:'.btn-arrow.next',
                swipeToSlide: true,
                slidesToShow: 6,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 20000,
                    settings: {
                        slidesToShow: 6
                    }
                }, {
                    breakpoint: 1270,
                    settings: {
                        slidesToShow: 5
                    }
                }, {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 4
                    }
                }, {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3
                    }
                }, {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                }]
            });
        });
    }

    // BTOCSITE-26022, PDP 컴포넌트 초기화 함수 추가, type: PROD or CONTENTS
    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'CONTENTS', name: 'KRC0009', isFirstLoad: false, fn: function () {
                if(!document.querySelector('.KRC0009')) return false;
                funcReady();
            }
        });
    }

    SAVE_COMPONENT_PDP_DOM_MNG();

    $(window).ready(function(){
        SAVE_COMPONENT_PDP_DOM_MNG();

        if(!document.querySelector('.KRC0009')) return false;
        funcReady();
    });
})();

